export const THEME_MODES = ["system", "light", "dark"];
export const THEME_STORAGE_KEY = "webcrm-theme";

export function getInitialThemeMode() {
    return localStorage.getItem(THEME_STORAGE_KEY) || "light";
}

export function resolveTheme(mode) {
    if (mode === "system") {
        return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
    }
    return mode;
}

export function applyThemeToDocument(mode) {
    const resolved = resolveTheme(mode);
    document.documentElement.dataset.theme = resolved;
    document.documentElement.dataset.themeMode = mode;
    return resolved;
}
